<template>

  <div class="page works">

  	<!-- WORKS LIST (SMALL) -->
  	<section id="works">

      <div id="selected-works" class="container">
        <div class="down-arrow"></div>
      </div>

      <ts-works-list></ts-works-list>
    </section>

    <ts-footer></ts-footer>

  </div>

</template>


<script>

// @ is an alias to /src
import sal from 'sal.js'
import TsWorksList from '@/components/TSWorksList.vue'
import TsFooter from '@/components/TSFooter.vue'

export default {

  name: 'Works',

  components: {
    TsWorksList,
    TsFooter
  },

  mounted() {
    this.$root.$emit('show-shapes', true)
  }

}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#landing {
  transition-delay: 1s;
}

#works,
#selected-works {
  margin-top: 0px;
  margin-bottom: 0px;
}


</style>
